import { getLanguageDirection } from '@/i18n/supportedLanguages';
import { useTranslation } from 'react-i18next';

export type EffectiveDirection = 'ltr' | 'rtl';

/** The locale-derived direction — what `src/app/mainConfig` already derives
 *  for `document.dir` / the v1 surfaces: ar_AR → 'rtl', everything else
 *  'ltr'. Since the accessibility-modal rework this is the ONLY direction
 *  input — the manual Auto/LTR/RTL override was removed (a legacy stored
 *  pref is silently dropped by themeStore's prefs heal-write). */
export const useLocaleDirection = (): EffectiveDirection => {
  const { i18n } = useTranslation();
  return getLanguageDirection(i18n.language);
};

/** v4 shell direction — kept as the consumer-facing name (AppShell's
 *  SidebarProvider, dialogs, rails); now identical to the locale direction. */
export const useEffectiveDirection = (): EffectiveDirection => useLocaleDirection();
